import React from "react";
import { useBnbSelector } from "../../../redux/store";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import { BnbLabel, useBnbOptionalLabel } from "../../../utils/labels";
import ETADeliveryLabel from "../common/ETADeliveryLabel";
import Price from "../common/price/Price";
import type { AlternativesETAModalType } from "../../../utils/modalConstants";
import * as Modal from "../../../../../../common-deprecated/styles/v2/lexus/globals/Modal";
import * as Flex from "../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as Type from "../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import * as Styles from "./styles/AlternativesETAModal";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { ImageFluid } from "../../../../../../common-deprecated/styles/v2/lexus/globals/Image";
import ButtonSecondary from "../../../../../../common-deprecated/components/aem/lexus/button/ButtonSecondary";
import { trackEtaOpenSelect } from "../../../utils/tracking";
import { getEtaAlternativeUrl } from "../../../utils/typedUtils";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";

const AlternativesETAModal = (props: ModalViewType<AlternativesETAModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const { alternatives } = useBnbSelector((state) => state.eta);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const urlStockCarsLandingPage = useBnbSelector((state) => state.bnbSettings.urlStockCarsLandingPage);

    const [viewStockCarsLabel, viewStockCarsDescriptionLabel] = useBnbOptionalLabel([
        "viewStockCars",
        "viewStockCarsDescription",
    ]);

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="lg">
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel label="alternatives" />
                </Modal.Title>
                <Modal.Close onClick={close}>
                    <IconWrapper>
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Close>
            </Modal.Header>
            <Modal.Body>
                <Flex.Col display="flex" p={5} flexWrap="wrap">
                    {alternatives.map((car) => (
                        <Styles.CarWrapper
                            key={`${car.id}-${car.colour.internalCode || car.colour.code}-${
                                car.upholstery.internalCode
                            }`}
                        >
                            <ETADeliveryLabel date={(car.eta && car.eta.date) || ""} />
                            <Type.H3 headingType="base" textTransform="uppercase" mb={3}>
                                {car.grade.name}
                            </Type.H3>
                            <Type.Text color="grey4">
                                {car.body.name} - {car.motorization.engine.name} - {car.motorization.transmission.name}
                            </Type.Text>
                            <Styles.PriceContainer>
                                {/* Div needed for mobile layout */}
                                <Price price={car.price} financeInfo={car.financeInfo} />
                            </Styles.PriceContainer>
                            <ImageFluid
                                src={car.carImage}
                                alt={`${car.model.name} ${car.body.name} ${car.grade.name} ${car.motorization.engine.name} ${car.motorization.transmission.name}`}
                            />
                            <ButtonSecondary
                                fullWidth
                                onClick={() => {
                                    trackEtaOpenSelect();
                                    window.location.href = getEtaAlternativeUrl(commonSettings, car);
                                }}
                            >
                                <BnbLabel label="chooseThisGrade" />
                            </ButtonSecondary>
                        </Styles.CarWrapper>
                    ))}
                    {!!urlStockCarsLandingPage && !!viewStockCarsLabel && (
                        <Flex.Col width={{ xs: 1 }} justifyContent="center" display="flex" mt={5}>
                            <Styles.CTAContainer width={{ xs: 1, sm: 1 / 4 }}>
                                {!!viewStockCarsDescriptionLabel && (
                                    <Type.Text headingType="base">{viewStockCarsDescriptionLabel}</Type.Text>
                                )}
                                <ButtonSecondary fullWidth href={urlStockCarsLandingPage}>
                                    {viewStockCarsLabel}
                                </ButtonSecondary>
                            </Styles.CTAContainer>
                        </Flex.Col>
                    )}
                </Flex.Col>
            </Modal.Body>
        </ModalBaseView>
    );
};

export default AlternativesETAModal;
